import React from 'react';
import { createPortal } from 'react-dom';

const id = 'breadcrumbs-portal';
/**
 * Portal that renders children into a DOM node outside the React app.
 *
 * Uses the div with id "breadcrumbs-portal"
 * Returns null if the target element doesn't exist.
 */
const BreadcrumbsPortal = ({ children }) => {
  if (typeof document === 'undefined') return null;
  const element = document.getElementById(id);

  if (!element) return null;

  return createPortal(children, element);
};

export default BreadcrumbsPortal;
